import React from 'react'

const CaseContext = React.createContext(null)

export const Provider = CaseContext.Provider
export const Consumer = CaseContext.Consumer

export default CaseContext
